export const detectFileType = (url) => {
  if (!url) return "unknown";

  if (url.startsWith("data:")) {
    if (url.includes("application/pdf")) return "pdf";
    if (url.includes("image/")) return "image";
    return "unsupported";
  }

  const urlWithoutQueryParams = url.split("?")[0].split("#")[0];
  const lastSegment = urlWithoutQueryParams.split(".").pop().toLowerCase();
  const extension = lastSegment.length <= 5 ? lastSegment : "";

  if (["png", "jpg", "jpeg", "gif", "svg"].includes(extension)) return "image";
  if (extension === "pdf") return "pdf";
  return "unsupported";
};
